const Swal = require('sweetalert2')

export function setAddAddressFormListener(onSubmit) {
  const addAddressForm = $("#addAddressForm");
  addAddressForm.submit(function (e) {
    e.preventDefault();
    const formData = {};
    $("#addAddressForm")
      .serializeArray()
      .map((x) => {
        formData[x.name] = x.value;
        console.log('serialized', x.value, x.name);
      });
    
    let coords = $('#address_coords').val().split(',') || []
    let delivery_price = $('#address_price').val();
    const freefromPrice = formData.default_freefrom_price;
    console.log(freefromPrice);
    console.log('coords', coords, delivery_price);
    console.log('formData', formData);

    if (coords.length < 1 || !delivery_price) {
      Swal.fire({
        title: `Адрес не найден!`,
        text: `Пожалуйста, воспользуйтесь картой!`,
        icon: 'warning',
        // confirmButtonText: '<a href="/index.html">На главную</a>',
        allowOutsideClick: false
      })
      // alert('Не удалось найти ваш адрес. Пожалуйста, воспользуйтесь картой!')
      return
    }

    const addressData = {
      address: `${formData.street} ${formData.number || ''}`,
      entrance: formData.entrance,
      apartment: formData.apartment,
      floor: formData.floor,
      comment: formData.comment,
      guestname: formData.guestname,
      guestphone: formData.guestphone,
      latitude: coords[0],
      longitude: coords[1],
      deliveryrate: formData.deliveryrate,
      block: formData.block
    };
    console.log(addressData);

    if(!(formData.address && formData.address.length)) {
      return;
    }

    api.createAddresses(addressData)
      .then((data) => {
        $('#addAddress').hide();
        $('#profile_addressName').val('');
        api.getAddresses()
          .then((addresses) => {
            content.hideModalWindows(true);
            content.setProfileAddresses(addresses);
            content.setCheckoutTotals(delivery_price, freefromPrice);
            //delivery_price
            onSubmit && onSubmit(addresses, data.data.address_uuid || '', formData);
          })

      })

  })

}
